import { Button, ButtonVariants, Modal } from '@comptia-sso/core';
import { ReactElement } from 'react';
import { useTranslation, Trans } from 'react-i18next';

import styles from './MissingProductsModal.module.scss';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onLinkAccount: () => void;
};

export const MissingProductsModal = ({
  isOpen,
  onClose,
  onLinkAccount,
}: Props): ReactElement => {
  const { t } = useTranslation();

  return (
    <Modal
      title={t('MissingProductsModal.Title')}
      open={isOpen}
      onClose={onClose}
    >
      <div>
        <p>
          <Trans
            i18nKey="MissingProductsModal.Content1"
            components={{
              linktag: <a href={t('Links.LegacyAccount')} />,
            }}
          />
        </p>
        <p>{t('MissingProductsModal.Content2')}</p>
        <p>{t('MissingProductsModal.Content3')}</p>
        <ul>
          <li>{t('MissingProductsModal.Item1')}</li>
          <li>{t('MissingProductsModal.Item2')}</li>
          <li>{t('MissingProductsModal.Item3')}</li>
        </ul>
      </div>
      <a href={t('Links.LegacyAccount')}>
        {t('MissingProductsModal.Content4')}
      </a>
      <div className={styles.buttons}>
        <Button variant={ButtonVariants.Secondary} onClick={onClose}>
          {t('MissingProductsModal.Button1')}
        </Button>
        <Button variant={ButtonVariants.Primary} onClick={onLinkAccount}>
          {t('MissingProductsModal.Button2')}
        </Button>
      </div>
    </Modal>
  );
};
